/** Formateadores de presentación (moneda, fechas, identificadores). */

export const MONTHS_SHORT = [
  "ene", "feb", "mar", "abr", "may", "jun",
  "jul", "ago", "sep", "oct", "nov", "dic",
] as const;

export const MONTHS_LONG = [
  "enero", "febrero", "marzo", "abril", "mayo", "junio",
  "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre",
] as const;

export const DOW_SHORT = ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"] as const;

/** Formatea pesos chilenos: 18900 → "$18.900". */
export function money(value: number): string {
  return "$" + value.toLocaleString("es-CL");
}

/** Identificador corto y único. */
export function uid(): string {
  return Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
}

/** Convierte "YYYY-MM-DD" a Date a mediodía (evita el corrimiento por timezone). */
export function fromISO(iso: string): Date {
  return new Date(`${iso}T12:00:00`);
}

/** "YYYY-MM-DD" → "12 de marzo de 2026". */
export function formatDateLong(iso: string): string {
  const d = fromISO(iso);
  return `${d.getDate()} de ${MONTHS_LONG[d.getMonth()]} de ${d.getFullYear()}`;
}

/** "YYYY-MM-DD" → "12 mar". */
export function formatDateShort(iso: string): { day: number; month: string } {
  const d = fromISO(iso);
  return { day: d.getDate(), month: MONTHS_SHORT[d.getMonth()] };
}

/** Normaliza un teléfono: solo dígitos (para comparar/enlaces wa.me). */
export function digitsOnly(phone: string): string {
  return phone.replace(/\D/g, "");
}

/** Escapa HTML para insertar texto de usuario (nombres, notas) de forma segura. */
export function escapeHTML(value: string): string {
  return value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}
